import { MagnifyingGlassIcon } from "@heroicons/react/24/outline";
import { ButtonInput } from "../shared/Inputs/ButtonInput";
import useWilmaUsers from "../../data/useWilmaUsers";

interface WorkOrdersSearchBarProps {
  search: string;
  onSearchChange: (value: string) => void;
  status: string;
  onStatusChange: (value: string) => void;
  priority: string;
  onPriorityChange: (value: string) => void;
  showAssigneeFilter: boolean;
  assignee: string;
  onAssigneeChange: (value: string) => void;
  statusOptions: { label: string; value: string }[];
  priorityOptions: { label: string; value: string }[];
  onNewOrderClick: () => void;
}

export default function WorkOrdersSearchBar({
  search,
  onSearchChange,
  status,
  onStatusChange,
  priority,
  onPriorityChange,
  showAssigneeFilter,
  assignee,
  onAssigneeChange,
  statusOptions,
  priorityOptions,
  onNewOrderClick,
}: WorkOrdersSearchBarProps) {
  const { wilmaUsers } = useWilmaUsers();


  return (
    <div className="mt-4 bg-white shadow rounded-lg p-3">
      <div className="flex flex-col lg:flex-row lg:items-center gap-3">
        <div className="relative w-full lg:flex-1">
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            <MagnifyingGlassIcon className="h-5 w-5 text-gray-400" />
          </div>
          <input
            type="text"
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
            placeholder="Search work orders..."
            className="w-full rounded-md border border-gray-300 pl-10 pr-3 py-2 text-sm focus:border-primary-500 focus:outline-none focus:ring-1 focus:ring-primary-500"
          />
        </div>

        <select
          value={status}
          onChange={(e) => onStatusChange(e.target.value)}
          className="w-full lg:w-44 rounded-md border border-gray-300 px-3 py-2 text-sm"
        >
          <option value="all">All Status</option>
          {statusOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        <select
          value={priority}
          onChange={(e) => onPriorityChange(e.target.value)}
          className="w-full lg:w-44 rounded-md border border-gray-300 px-3 py-2 text-sm"
        >
          <option value="all">All Priority</option>
          {priorityOptions.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>

        {showAssigneeFilter && (
          <select
            value={assignee}
            onChange={(e) => onAssigneeChange(e.target.value)}
            className="w-full lg:w-44 rounded-md border border-gray-300 px-3 py-2 text-sm"
          >
            <option value="all">All Assignees</option>
            <option value="unassigned">Unassigned</option>
            {wilmaUsers.data?.data.map((user) => (
              <option key={user.id} value={user.id}>
                {user.fullname}
              </option>
            ))}
          </select>
        )}

        <div className="w-full lg:w-auto lg:ml-0">
          <ButtonInput label="+ New Order" isSubmit={false} onClick={onNewOrderClick} classes="w-full lg:w-auto whitespace-nowrap" />
        </div>
      </div>
    </div>
  );
}
